import { appDataName } from "../../app/dataTypes";
import { RootState } from "../../app/rootReducer";
import { formDefinitionSliceName } from "./dataTypes";
import { formDefinitionAdapter } from "./formDefinitionAdapter";

const selectSliceState = (state: RootState) => state[appDataName][formDefinitionSliceName];

const adapterSelectors = formDefinitionAdapter.getSelectors(selectSliceState);

export const selectErrorMessage = (state: RootState) => selectSliceState(state).errorMessage;

export const selectRequestState = (state: RootState) => selectSliceState(state).requestState;

export const selectFormDefinitionEntities = adapterSelectors.selectEntities;
export const selectFormDefinitions = adapterSelectors.selectAll;
export const selectFormDefinition = (id = "") => (state: RootState) => adapterSelectors.selectById(state, id);
